import React from 'react';
import { ContentState } from 'draft-js';
import { sanitizeHrefValue } from 'Shared/components/DraftEditor/utils';

import Colors from 'Wpds/colors/ColorConstants';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

type Props = {
  entityKey: string;
  contentState: ContentState;
  children: React.ReactNode;
};

function AddPluginLink({ entityKey, contentState, children }: Props) {
  const { href } = contentState.getEntity(entityKey).getData();

  const handleLinkClick = event => {
    event.preventDefault();
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  return (
    <WpTooltip>
      <WpTooltipTrigger>
        <a
          className="font-weight-bold"
          style={{ color: Colors.purple[800] }}
          href={sanitizeHrefValue(href)}
          rel="noopener noreferrer"
          target="_blank"
          onClick={handleLinkClick}
        >
          {children}
        </a>
      </WpTooltipTrigger>
      <WpTooltipContent>{href}</WpTooltipContent>
    </WpTooltip>
  );
}

export default AddPluginLink;
